import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import classes from './Home12Header.module.scss';

const menuItems = [
    { to: '/', label: 'トップ' },
    { to: '/services', label: 'サービス' },
    { to: '/construction', label: '建築事業' },
    { to: '/download', label: '資料請求' },
    { to: '/contact', label: 'お問い合わせ' },
    { to: '/company', label: '運営会社' }
];

const isActivePath = (pathname, targetPath) => {
    if (targetPath === '/') {
        return pathname === '/';
    }
    return pathname.startsWith(targetPath);
};

const Home12Header = ({ mode = 'sticky' }) => {
    const location = useLocation();
    const [isMenuOpen, setIsMenuOpen] = React.useState(false);

    React.useEffect(() => {
        setIsMenuOpen(false);
    }, [location.pathname]);

    return (
        <>
            <header
                className={`${classes.header} ${mode === 'fixed' ? classes.fixed : classes.sticky}`}
                data-home12-header
            >
                <Link to="/" className={classes.logo}>
                    <img src="/react-assets/logo-icon.svg" alt="icon" />
                    collabo
                </Link>

                <nav className={classes.desktopNav} aria-label="home12 menu">
                    {menuItems.map((item) => (
                        <Link
                            key={item.to}
                            to={item.to}
                            className={`${classes.menuItem} ${isActivePath(location.pathname, item.to) ? classes.menuItemActive : ''}`}
                        >
                            {item.label}
                        </Link>
                    ))}
                </nav>

                <button
                    type="button"
                    aria-label="メニューを開く"
                    aria-expanded={isMenuOpen}
                    className={`${classes.menuButton} ${isMenuOpen ? classes.menuButtonOpen : ''}`}
                    onClick={() => setIsMenuOpen((open) => !open)}
                >
                    <span className={classes.menuButtonBar} />
                </button>
            </header>

            <nav
                className={`${classes.mobileMenu} ${isMenuOpen ? classes.mobileMenuOpen : ''}`}
                aria-label="home12 mobile menu"
            >
                {menuItems.map((item) => (
                    <Link
                        key={item.to}
                        to={item.to}
                        className={`${classes.menuItem} ${isActivePath(location.pathname, item.to) ? classes.menuItemActive : ''}`}
                    >
                        {item.label}
                    </Link>
                ))}
            </nav>
        </>
    );
};

export default Home12Header;
